"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const videofilled = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-videofilled` : '') + (description ? ` desc-videofilled` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-videofilled"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-videofilled"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M1 1.75097C1 1.22828 1.51568 0.876898 1.99104 1.04047L2.08541 1.08015L23.0854 11.5801C23.6036 11.8393 23.636 12.5488 23.1826 12.8642L23.0854 12.9218L2.08541 23.4218C1.6179 23.6555 1.073 23.3514 1.00671 22.8531L1 22.751V1.75097Z",
    fill: "inherit"
  }));
};
var _default = exports.default = videofilled;